import {
  FETCH_ACCESS_POINTS,
  ADD_ACCESS_POINT,
  REMOVE_ACCESS_POINT,
  FETCH_BUILDINGS,
  EDIT_ACCESS_POINT
} from "../actions/types";

const INITIAL_STATE = {
  buildings: [],
  accessPoints: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ACCESS_POINTS:
      return { ...state, accessPoints: action.payload };
    case FETCH_BUILDINGS:
      return { ...state, buildings: action.payload };
    case ADD_ACCESS_POINT:
    case EDIT_ACCESS_POINT:
    case REMOVE_ACCESS_POINT:
      return { ...state };
    default:
      return state;
  }
};
